import { render, staticRenderFns } from "./CreditNoteAdd.vue?vue&type=template&id=133b5b15&scoped=true"
import script from "./CreditNoteAdd.vue?vue&type=script&lang=js"
export * from "./CreditNoteAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b5b15",
  null
  
)

export default component.exports